/**
 * Markdown rendering utilities
 * Configured for code syntax highlighting
 */

import { marked } from 'marked'
import hljs from 'highlight.js'

/**
 * Configure marked with highlight.js
 */
export const configureMarked = () => {
  marked.setOptions({
    highlight: function (code, lang) {
      if (lang && hljs.getLanguage(lang)) {
        try {
          return hljs.highlight(code, { language: lang }).value
        } catch (err) {
          console.error('Highlight error:', err)
        }
      }
      return hljs.highlightAuto(code).value
    },
    breaks: true, // Enable line breaks
    gfm: true, // GitHub Flavored Markdown
  })
}

// Configure on import
configureMarked()

/**
 * Render markdown to HTML
 * @param {string} markdown - Markdown text
 * @returns {string} HTML string
 */
export const renderMarkdown = (markdown) => {
  try {
    return marked.parse(markdown)
  } catch (error) {
    console.error('[Markdown] Render error:', error)
    return `<p>${escapeHtml(markdown)}</p>`
  }
}

/**
 * Escape HTML to prevent XSS
 * @param {string} text
 * @returns {string}
 */
export const escapeHtml = (text) => {
  const div = document.createElement('div')
  div.textContent = text
  return div.innerHTML
}

/**
 * Convert plain text to HTML (with line breaks)
 * @param {string} text
 * @returns {string}
 */
export const textToHtml = (text) => {
  return escapeHtml(text).replace(/\n/g, '<br>')
}
